import { Experiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'
import { useAppSelector } from 'hooks/reduxHooks'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'
import type { EnabledFilters } from 'components/Search/type'

/** svc-search rollout flag that dual-surfaces facilities / room amenities / bed types. */
export const HOTEL_FILTER_SECTIONS_V2_ROLLOUT = 'hotel_filter_sections_v2'

const HOTEL_SEARCH_RESULTS_ROUTES = [
  '/:regionCode/search',
  '/:regionCode/search/map',
]

export function isHotelSearchResultsPath(pathname: string): boolean {
  return !!matchLocaleAwarePath(pathname, { path: HOTEL_SEARCH_RESULTS_ROUTES, exact: true })
}

export function withHotelFilterSectionsV2EnabledFilters(
  enabledFilters: EnabledFilters,
  isHotelFilterSectionsV2: boolean,
): EnabledFilters {
  if (!isHotelFilterSectionsV2) return enabledFilters

  return {
    ...enabledFilters,
    amenities: false,
    propertyFacilities: true,
    roomAmenities: true,
    bedTypes: true,
    bedrooms: true,
    beds: false,
  }
}

/**
 * Hotel filter sections v2 A/B. Treatment drives both the filter UI and the
 * matching svc-search rollout so facet presentation stays in sync with the cohort.
 * Scoped to hotel search list and map so toggling views keeps the same filter set.
 */
function useHotelFilterSectionsV2Experiment() {
  const pathname = useAppSelector(state => state.router.location.pathname)
  const isHotelSearchResultsPage = isHotelSearchResultsPath(pathname)
  const { isAnyVariant } = useExperiment(Experiments.searchHotelFilterSectionsV2, {
    canActivate: isHotelSearchResultsPage,
  })

  return { isAnyVariant: isAnyVariant && isHotelSearchResultsPage }
}

export default useHotelFilterSectionsV2Experiment
